import { clsx } from 'clsx'
import { type FC } from 'react'

import { usePrepareDeliveryTableDataSae } from './usePrepareDeliveryTableDataSae'

export const ProductDeliveryInfoTableSae: FC = () => {
  const { bodyRows, headerRow } = usePrepareDeliveryTableDataSae()

  const sharedClassNames = 'h-16 border-l border-dark-primary-min'

  const headerCellClassNames = clsx('text-m font-medium', sharedClassNames)

  const cellClassNames = clsx(sharedClassNames, 'border-t font-medium')

  return (
    <table
      cellSpacing="0"
      className="w-full table-fixed border-separate overflow-hidden rounded border border-dark-primary-min bg-light-primary-low text-center"
    >
      <thead>
        <tr>
          {headerRow.map((headerCellElement, index) => (
            <th
              className={clsx(
                headerCellClassNames,
                index === 0 && 'border-l-0',
              )}
              // eslint-disable-next-line react/no-array-index-key -- all the maps in this file don't change in runtime
              key={index}
            >
              {headerCellElement.content}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {bodyRows.map((row, rowIndex) => {
          return (
            // eslint-disable-next-line react/no-array-index-key -- the rule was disabled before a comment became required
            <tr key={rowIndex}>
              {row.map((cellElement, cellIndex) => {
                if (cellElement.isWithinPreviousRowSpan) {
                  return null
                }

                return (
                  <td
                    className={clsx(
                      cellClassNames,
                      cellIndex === 0 && 'border-l-0',
                    )}
                    // eslint-disable-next-line react/no-array-index-key -- the rule was disabled before a comment became required
                    key={cellIndex}
                    rowSpan={cellElement.rowSpan}
                  >
                    {cellElement.content}
                  </td>
                )
              })}
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}
